import { render, staticRenderFns } from "./tabs-form.vue?vue&type=template&id=0993f000"
import script from "./tabs-form.vue?vue&type=script&lang=js"
export * from "./tabs-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports